import React from 'react'
import PropTypes from 'prop-types'

const WRAPPER_CLASSES = 'tw:flex tw:h-52 tw:flex-col tw:items-center tw:justify-center '
  + 'tw:gap-4 tw:px-6 tw:text-center'

const ICON_WRAPPER_CLASSES = 'tw:flex tw:items-center tw:justify-center tw:shrink-0 '
  + 'tw:w-12 tw:h-12 tw:rounded-md! tw:bg-gray-100'

const ICON_CLASSES = 'fas tw:text-3xl tw:text-ds-neutral-highest'

const TEXT_GROUP_CLASSES = 'tw:flex tw:flex-col tw:items-center tw:gap-1.5'

const TITLE_CLASSES = 'tw:m-0! tw:text-lg! tw:font-semibold! tw:text-ds-neutral-highest'

const MESSAGE_CLASSES = 'tw:m-0! tw:max-w-md tw:text-sm tw:text-gray-500'

const iconClass = icon => icon.startsWith('fa-') ? icon : `fa-${icon}`

const EmptyState = ({
  action = null,
  icon = 'search',
  message = '',
  title = 'Aucune donnée'
}) => (
  <div className={WRAPPER_CLASSES}>
    <div className={ICON_WRAPPER_CLASSES}>
      <i className={`${ICON_CLASSES} ${iconClass(icon)}`} />
    </div>
    <div className={TEXT_GROUP_CLASSES}>
      <h3 className={TITLE_CLASSES}>{title}</h3>
      {message ? <p className={MESSAGE_CLASSES}>{message}</p> : null}
    </div>
    {action}
  </div>
)

EmptyState.propTypes = {
  action: PropTypes.node,
  icon: PropTypes.string,
  message: PropTypes.string,
  title: PropTypes.string
}

EmptyState.defaultProps = {
  action: null,
  icon: 'search',
  message: '',
  title: 'Aucune donnée'
}

export default EmptyState
